import React, {Component} from "react";
import begin1a from '../../../../../assets/img/begin1a.png';
import begin2new from '../../../../../assets/img/begin2new.png';
import begin3new from '../../../../../assets/img/begin3new.png';
import begin4new from '../../../../../assets/img/begin4new.png';
import begin5new from '../../../../../assets/img/begin5new.png';
import begin6new from '../../../../../assets/img/begin6new.png';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import img1a from "../../../../../assets/img/kitcut-footer--pages-images/page6-1a.png";
import img1b from "../../../../../assets/img/kitcut-footer--pages-images/page6-1b.png";
import img2 from "../../../../../assets/img/kitcut-footer--pages-images/page6-2.png";
import img3 from "../../../../../assets/img/kitcut-footer--pages-images/page6-3.png";
import img4 from "../../../../../assets/img/kitcut-footer--pages-images/page6-4.png";
import img5a from "../../../../../assets/img/kitcut-footer--pages-images/page6-5a.png";
import img5b from "../../../../../assets/img/kitcut-footer--pages-images/page6-5b.png";
import img5c from "../../../../../assets/img/kitcut-footer--pages-images/page6-5c.png";
import img6a from "../../../../../assets/img/kitcut-footer--pages-images/page6-6a.png";
import img6b from "../../../../../assets/img/kitcut-footer--pages-images/page6-6b.png";
import img7 from "../../../../../assets/img/kitcut-footer--pages-images/page6-7.png";


class Page6 extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }

    render() {
        return (
            <div className="faq-page-layout">
                <div className="beginners-background-div footer-nav-pages-background">
                    <h3 className='font-size-30 yu-gothic-bold '>
                        OrCAD ガーバーデータ出力方法
                    </h3>
                    <p className='all-content-font-size'>
                        <b>1.エクスポート ＝＞Gerberを選択します。</b>
                    </p>
                    <div className='row'>
                        <p className='all-content-font-size col-md-7 '>
                            <img className="img-size-footer-nav resp-footer-nav-img" src={img1a} alt=""/>
                        </p>
                        <p className='all-content-font-size col-md-5'>
                            <img className="img-size-footer-nav" src={img1b} alt=""/>
                        </p>
                    </div>
                    <br/>

                    <p className='all-content-font-size'>
                        ArtworkControlフォームから <b>「General Parameters」 </b>タブ＝＞RS274xを選択し、各種設定を行います。
                    </p>
                    <p className='all-content-font-size '>
                        <img className="img-size-footer-nav" src={img2} alt=""/>
                    </p>
                    <br/>

                    <p className='all-content-font-size'>
                        表示した時に設定されている、Etch Class（配線クラス）の全てのSubclass（各配線層）が自動的にフォーム左側のAvalable
                        Filmにリスト表示されますので、
                        <br/>
                        それ以外の出力したいClass/Subclass（マスクなど）をAvalable Film内で定義してください。
                        <br/>
                        各Filmの詳細設定についてはフォーム右のFilm Optionで設定します。
                    </p>
                    <p className='all-content-font-size '>
                        <img className="img-size-footer-nav resp-footer-nav-img" src={img3} alt=""/>
                    </p>
                    <br/>

                    <p className='all-content-font-size'>
                        ガーバー出力したいファイル名にチェックをし、<b> 「Create Artworkボタン」</b>をクリックするとディレクトリに Film名.art という名前のガーバーファイルを出力します。
                        <br/>
                        BOTTOM.art / TOP.art
                        CreateArtwrok実行ログはphotoplot.logファイルに出力されます。
                    </p>
                    <p className='all-content-font-size '>
                        <img className="img-size-footer-nav resp-footer-nav-img" src={img4} alt=""/>
                    </p>
                    <br/>

                    <p className='all-content-font-size'>
                        <b>NCドリルファイルの作成</b> <br/>
                        メニューより、 <b>「Export」 > 「NC Parameters」 </b>を選択すると ドリルパラメータが表示されますので各パラメータを設定します。
                    </p>
                    <div className='row'>
                        <p className='all-content-font-size col-md-6 '>
                            <img className="img-size-footer-nav resp-pg6-img" src={img5a} alt=""/>
                        </p>
                        <p className='all-content-font-size col-md-2'>
                            <img className="img-size-footer-nav" src={img5b} alt=""/>
                        </p>
                        <p className='all-content-font-size col-md-4'>
                            <img className="img-size-footer-nav" src={img5c} alt=""/>
                        </p>
                    </div>
                    <br/>

                    <p className='all-content-font-size'>
                        メニューより、 <b>「Export」 > 「NC Drill」</b>を選択すると
                        ドリルフォームが表示されます。
                    </p>
                    <div className='row'>
                        <p className='all-content-font-size col-md-6 '>
                            <img className="img-size-footer-nav resp-pg6-img" src={img6a} alt=""/>
                        </p>
                        <p className='all-content-font-size col-md-6'>
                            <img className="img-size-footer-nav resp-pg6-img" src={img6b} alt=""/>
                        </p>

                    </div>
                    <br/>


                    <p className='all-content-font-size'>
                        各種必要な設定を行い <b>「Drill」 </b>をクリックすると、起動ディレクトリにdrill-x-x.drlという名前のドリルファイルを出力します。
                    </p>
                    <p className='all-content-font-size '>
                        <img className="img-size-footer-nav" src={img7} alt=""/>
                    </p>
                    <br/>

                    <p className='all-content-font-size'>
                        各ガーバーファイルを作成したら、必ずGerberビューアーを使用して
                        、問題がないことを確認してください。
                        <br/>
                        それらのファイルを圧縮してKITCUT PCB注文ページにアップロードします。
                    </p>


                </div>
            </div>
        );
    }
}

export default Page6;


// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/FooterNavigationPages/FooterNavPages/page6.js